<template>
    <ul class="ui-checklist">
        <li v-for="option in options" :key="option.id" class="ui-checklist__row">
            <label>
                <input 
                  type="checkbox" 
                  :checked="option.checked" 
                  :disabled="disabled" 
                  @change="onCheckboxChange($event, option.id)"
                >
                <span>{{ option.label }}</span>
            </label>
        </li>
    </ul>
</template>

<script>
export default {
    name: "UiChecklist",
    props: ["options", "disabled"],
    methods: {
        onCheckboxChange($event, id) {
            this.$emit('change', id, $event.currentTarget.checked);
        }
    }
};
</script>

<style scoped>
.ui-checklist {
    list-style: none;
    padding-left: 0;
    min-width: 200px;
    margin: 0;
}

.ui-checklist__row {
    display: flex;
    align-items: flex-start;
}
</style>